import React from "react"
import { Stack } from "@mui/material"

const styles = {
	flexBasis: { xs: "100%", sm: "calc(50% - 10px)" }
}

export default function FieldGroup({ children }) {
	return <Stack sx={styles}>{children}</Stack>
}
